import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 80%;
  text-align: center;

  .ant-avatar-group {
    align-items: center;
  }
`;
